'use client';

import type { ReactNode } from 'react';
import { VStack } from '@terra/ui-styled-system';
import { EndpointsRenderer } from '../../ToolCallsRenderers/renderers/EndpointsRenderer';
import { JSONRenderer } from '../../ToolCallsRenderers/renderers/JSONRenderer';
import { PlainTextRenderer } from '../../ToolCallsRenderers/renderers/PlainTextRenderer';
import type { OutputRenderContext } from '../../tool-config-types';
import { parseAssetsListContent } from './assets-list-parser';
import { WebPagesRenderer } from '../web-pages/WebPagesRenderer';

export const renderAssetsListResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight, onOpenObject } = ctx;
  const parsed = parseAssetsListContent(content);
  const hasEndpoints = (parsed?.endpoints.length ?? 0) > 0;
  const hasWebPages = (parsed?.webPages.length ?? 0) > 0;

  if (parsed && (hasEndpoints || hasWebPages)) {
    return (
      <VStack alignItems="stretch" gap={3} width="100%">
        {hasEndpoints ? (
          <EndpointsRenderer
            endpoints={parsed.endpoints}
            maxHeight={maxHeight}
            onOpenObject={onOpenObject}
          />
        ) : null}
        {hasWebPages ? (
          <WebPagesRenderer
            webPages={parsed.webPages}
            onOpenObject={onOpenObject}
          />
        ) : null}
      </VStack>
    );
  }

  if (typeof content === 'object' && content !== null) {
    return <JSONRenderer data={content} maxHeight={maxHeight} />;
  }

  return <PlainTextRenderer content={String(content)} maxHeight={maxHeight} />;
};
